import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { FormFeedback } from 'reactstrap';

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.misc.paises.edit}
                postUrl={api.misc.paises.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El País ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar País"}
                buttonTitle={"Editar País"}
                buttonIcon={"fa fa-pencil fa-lg"}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <div className="ui-field">
                        <label>Nombre</label>
                        <input type="text" name="nombre" className="form-control" autoFocus data-auto-focus="true" />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/misc/Pais/Edit.js